package com.devi3east.bashbuddy.ktor.stripe.responses

import com.devi3east.bashbuddy.account.organization.domain.models.StripeAccount
import kotlinx.serialization.Serializable

@Serializable
data class StripeDashboardResponse(
    val account: StripeAccount,
    val dashboardUrl: String
)